import { getHistory } from './utils'

export function setupRouteChangedHandler() {
  const _getHistory = (function () {
    return this.context.history || getHistory() || window.history
  }).bind(this)
  this._currLocKey = _getHistory().location.key
  this.usubscribeRouteChangedHandler = this.context.store.subscribe(() => {
    let prevLocKey = this._currLocKey
    this._currLocKey = _getHistory().location.key
    let locChanged = this._currLocKey !== prevLocKey
    console.log('RouteChangedHandler', locChanged)
    if(locChanged && !this.api.async.busy) this.api.async.setDone()
  })
}



// WEBPACK FOOTER //
// ./src/App.utils.js